export const FTL_COST_PAGE_NAME = "FTL Cost"

export const FTL_COST_PAGES = {
    TABLE: "table",
}

export const LIST_FTL_COST_CELLS = [
    { id: 'shortcode',label: 'Shortcode'},
    { id: 'averageCost',label: 'Average Cost'},
    { id: 'currency',label: 'Currency'}
];

export const CURRENCIES = [
    "USD",
    "CAD"
]
export const DEFAULT_SORT_BY_HEAD_CELL = 'shortcode';
export const ROWS_PER_PAGE_LABEL = "FTL Cost per page"
